import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setVisionEquipment = (state, { visionEquipmentData }) => {
  if (!visionEquipmentData) return state;
  return state.merge({ visionEquipmentData });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_VISION_EQUIPMENT,
    actionFunction: setVisionEquipment,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
